import { render, staticRenderFns } from "./CreateQuoteModal.vue?vue&type=template&id=64d137a2&scoped=true&"
import script from "./CreateQuoteModal.vue?vue&type=script&lang=js&"
export * from "./CreateQuoteModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuoteModal.vue?vue&type=style&index=0&id=64d137a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d137a2",
  null
  
)

export default component.exports